module.exports = __webpack_public_path__ + "static/sport/treaure.6eaab6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trea/treaure.png
// module id = 7cnQ
// module chunks = 0